import Yox from 'yox'

import template from './template/BreadcrumbItem.hbs'

import {
  RAW_STRING,
  RAW_BOOLEAN,
  RAW_STYLE_TYPE,
} from '../constant'

import {
  findComponentUpward,
} from '../util'

export default Yox.define({

  template,

  name: 'bell-BreadcrumbItem',

  propTypes: {
    last: {
      type: RAW_BOOLEAN,
    },
    className: {
      type: RAW_STRING,
    },
    style: {
      type: RAW_STYLE_TYPE,
    }
  },

  data(options) {
    const breadcrumb = findComponentUpward(options.parent, 'bell-Breadcrumb')
    return {
      separator: breadcrumb.get('separator')
    }
  }

})